import { Form, Select } from "antd";
import GlobalModal from "../../../../components/modal/GlobalModal";
import useModalStore from "../../../../zustand/store/useModalStore";
import ManageClientForm from "../manage-client/ManageClientForm";

const { Option } = Select;

const AddNewClient = () => {
  const [form] = Form.useForm();

  // Function to handle form submission
  const handleSubmit = (values) => {
    console.log("Submitted values:", values);
  };

  // Validation rules
  const validateMessages = {
    required: "${label} is required!",
  };
  const { openModal, closeModal } = useModalStore((state) => ({
    openModal: state.openModal,
    closeModal: state.closeModal,
  }));

  const handleOpenModal = (id) => {
    openModal(id); // Open modal with specific ID
  };

  return (
    <div>
      <button
        onClick={() => {
          handleOpenModal("manageClient-Modal-Id");
        }}
        className="crt-usr-btn  "
      >
        + Add New Client
      </button>

      <GlobalModal id="manageClient-Modal-Id" title="Create Client">
        <ManageClientForm />
      </GlobalModal>
    </div>
  );
};

export default AddNewClient;
